<template>
    <div class="user-list">
        <div v-for="user in participants" :key="user.id" class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <user-avatar :img-url="user.photo_url" :title="user.name" />
                </div>

                <div class="level-item">
                    {{ user.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '@/components/elements/Avatar.vue';

export default {
    components: { UserAvatar: Avatar },
    props: {
        participants: {
            type: Array,
            required: true,
        },
        online: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.user-list {
    height: 100%;
    overflow: auto;
    padding: $column-gap;
}
</style>
